export default __webpack_public_path__ + "static/media/raydium.e36ea755.svg";